import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';

type TaskDurationForecastInput = {
  taskId: string;
  queueId: string;
  start: string;
};

export const useTaskDurationForecast = ({ taskId, queueId, start }: TaskDurationForecastInput, enabled?: boolean) => {
  const api = useGraphneAPI();

  return useQuery({
    queryKey: ['task-duration-forecast', taskId, start, queueId],
    queryFn: () => api.getGraphneTasksTaskidDurationForecast({ taskId, queueId, start }),
    enabled,
  });
};
